/**
 * Created by Dongyuhua on 2019/1/21.
 */
module.exports={

  insertStr:(soure, start, newStr)=>{ //字符串指定位置插入字符

    return soure.slice(0, start) + newStr + soure.slice(start);
  },
  format:(fmtdate,fmt)=> { //格式化时间(mm-yy-dd)
    if(new Date(fmtdate).toString()==="Invalid Date"){
      return false;
    }
    fmtdate=new Date(fmtdate);
    var o = {
      "M+": fmtdate.getMonth() + 1, //月份
      "d+": fmtdate.getDate(), //日
      "h+": fmtdate.getHours(), //小时
      "m+": fmtdate.getMinutes(), //分
      "s+": fmtdate.getSeconds(), //秒
      "q+": Math.floor((fmtdate.getMonth() + 3) / 3), //季度
      "S": fmtdate.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (fmtdate.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  },


  myConsole:function(para){
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js